import dates from "componentsv2/tools/dates";
import cn from "classnames";
import utils from "../services/appointment";
import { useContext } from "../store/useContext";
import TooltipCard from "./TooltipCard";

export default function EventCard({ event, handleEvent, view, col }) {
  const { start_date, end_date, stackIndex, stackCount } = event;
  const { context } = useContext();
  const { minStartTime } = context;
  const start = new Date(start_date);
  const end = new Date(end_date);
  const day = dates.endOfDay(start).getDay() + 1;

  const { startHour } = utils.getHourRange(minStartTime, null);
  const startMinutes =
    start.getHours() * 60 + Math.floor(start.getMinutes() / 5) * 5;
  const offsetMinutes = startHour * 60;

  const gridRow = 2 + Math.floor((startMinutes - offsetMinutes) / 5);

  const durationMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
  const span = Math.ceil(durationMinutes / 5);

  const style = `${gridRow} / span ${span}`.toString();
  const colStart = view === "week" ? day : col || 1;

  // color viene de appointment_type definido en el backend
  const typeColor = event.appointment_type?.color || "#C0C0C0";
  const positionStyle =
    stackCount === 1
      ? {}
      : {
          width: `calc(${100 / stackCount}% - 4px)`,
          left: `calc(${(100 / stackCount) * stackIndex}% + 2px)`,
        };
  const patient =
    event.item?.["patient."]?.rec_name || event.patient || "Sin paciente";
  const patientName = patient?.name || "";
  const patientPhone = patient?.phone || "";

  const description = event.description || "";
  const comment = event.comment || "";

  const colorStyle = {
    backgroundColor:
      event.state === "show_up" ? `${typeColor}40` : `${typeColor}1a`,
    borderColor: typeColor,
  };

  return (
    <button
      type="button"
      onClick={(e) => handleEvent(e, event)}
      key={event.id}
      className={cn(
        "relative group my-1 flex responsive-column-start rounded-lg border m-2 transition-filter border-l-2",
      )}
      style={{
        gridRow: style,
        gridColumnStart: colStart,
        ...positionStyle,
        ...colorStyle,
      }}
    >
      <div
        className={cn(
          "absolute inset-1 flex flex-col rounded-lg text-xs/5 px-2 overflow-hidden",
        )}
      >
        <p className={cn("font-medium text-gray-700")}>{event.patient}</p>
        <p className={"text-gray-400"}>
          <time dateTime={event.start_date}>
            {dates.fmt(event.start_date, "HH:mm aa")}
          </time>
        </p>
        {patientName && (
          <p className={"text-gray-400"}>
            <span className="text-gray-500">
              {`( ${patientName}${patientPhone ? ` | ${patientPhone}` : ""} )`}
            </span>
          </p>
        )}

        {description && (
          <p className={"text-gray-400"}>
            <span className="text-gray-500">
              {`( ${description}${comment ? ` | ${comment}` : ""} )`}
            </span>
          </p>
        )}
      </div>
      <TooltipCard event={event} />
    </button>
  );
}
